
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mongtcauwrdswiblqwgh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vbmd0Y2F1d3Jkc3dpYmxxd2doIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY0NzYxMTAsImV4cCI6MjA2MjA1MjExMH0.xETtmjq-0Y6IjzV_RXeaB8lS0KpJMqU_obWrm6sWWhU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
